import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _fetchUploadsAttachments;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchUploadsAttachments as fetchUploadsAttachmentsApi } from '../../Repositories/helpdesk/v1/uploads-attachments';
import { objectUrlFileToBase64 } from '../../utils/objectUrlFileToBase64';
export function fetchUploadsAttachments(_x, _x2) {
  return (_fetchUploadsAttachments = _fetchUploadsAttachments || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var httpApi, logger, files, base64Content, parameters, uploadsAttachmentsResponse, filesState;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = _ref.httpApi, logger = _ref.logger;
          files = _ref2.files;
          _context.next = 4;
          return Promise.all(files.map(function (_ref3) {
            var objectUrl = _ref3.objectUrl;
            return objectUrlFileToBase64(objectUrl).catch(function (error) {
              logger.error(error);
              return '';
            });
          }));
        case 4:
          base64Content = _context.sent;
          parameters = {
            attachments: files.map(function (item, index) {
              return {
                filename: item.name,
                mimeType: item.mimeType,
                base64Content: base64Content[index]
              };
            })
          };
          _context.prev = 6;
          _context.next = 9;
          return fetchUploadsAttachmentsApi({
            httpApi: httpApi,
            parameters: parameters
          });
        case 9:
          uploadsAttachmentsResponse = _context.sent;
          if (!(uploadsAttachmentsResponse.statusCode === 400)) {
            _context.next = 13;
            break;
          }
          logger.warning("[Degradation] fetchUploadsAttachments: ".concat(uploadsAttachmentsResponse.response.message));
          return _context.abrupt("return", {
            files: files.map(function (sourceFile) {
              return {
                sourceFile: sourceFile,
                status: 'failed'
              };
            }),
            errorMessage: uploadsAttachmentsResponse.response.message || ''
          });
        case 13:
          filesState = files.map(function (sourceFile, index) {
            return {
              sourceFile: sourceFile,
              uploadedFile: uploadsAttachmentsResponse.response.uploadsTokens[index],
              status: 'succeed'
            };
          });
          return _context.abrupt("return", {
            files: filesState,
            errorMessage: '' // TODO закидывать возможные ошибки, произошедшие на предыдущих этапах
          });
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](6);
          logger.error(_context.t0);
          return _context.abrupt("return", {
            files: files.map(function (sourceFile) {
              return {
                sourceFile: sourceFile,
                status: 'failed'
              };
            }),
            errorMessage: 'Не удалось загрузить файлы'
          });
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 17]]);
  }))).apply(this, arguments);
}